import { MessageCircle, QrCode, ArrowRight } from 'lucide-react'

const BotAccess = () => {
  // Updated with actual bot username
  const botUsername = 'NyLaegeBot'
  const telegramBotUrl = `https://t.me/${botUsername}`

  return (
    <section className="section-padding bg-gradient-to-r from-green-50 to-blue-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          Kom i gang med Telegram Bot
        </h2>
        
        <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
          Klik på knappen nedenfor for at starte en chat med vores bot. 
          Du kan også scanne QR-koden med din telefon.
        </p>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Bot Access Card */}
          <div className="card">
            <div className="bg-primary/10 p-6 rounded-full w-24 h-24 mx-auto mb-6 flex items-center justify-center">
              <MessageCircle className="w-12 h-12 text-primary" />
            </div>
            
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Start chat med bot
            </h3>
            
            <p className="text-gray-600 mb-8">
              Klik på knappen for at åbne Telegram og starte en chat med vores bot. 
              Botten vil guide dig gennem opsætningen.
            </p>
            
            <a 
              href={telegramBotUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center text-lg"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              Åbn Telegram Bot
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            
            <p className="text-sm text-gray-500 mt-4">
              Har du ikke Telegram? 
              <a 
                href="https://telegram.org/apps" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:underline ml-1"
              >
                Download her
              </a>
            </p>
          </div>
          
          {/* QR Code Card */}
          <div className="card">
            <div className="bg-secondary/10 p-6 rounded-full w-24 h-24 mx-auto mb-6 flex items-center justify-center">
              <QrCode className="w-12 h-12 text-secondary" />
            </div>
            
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Scan QR-kode
            </h3>
            
            <p className="text-gray-600 mb-8">
              Scan QR-koden med din telefons kamera eller Telegram app 
              for hurtigt at åbne bot-chatten.
            </p>
            
            {/* QR Code Placeholder - In production, this would be generated dynamically */}
            <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg p-8 mb-6">
              <div className="w-48 h-48 mx-auto bg-white border border-gray-200 rounded-lg flex items-center justify-center">
                <div className="text-center">
                  <QrCode className="w-16 h-16 text-gray-400 mx-auto mb-2" />
                  <p className="text-sm text-gray-500">QR-kode kommer her</p>
                  <p className="text-xs text-gray-400 mt-1">@{botUsername}</p>
                </div>
              </div>
            </div>
            
            <p className="text-sm text-gray-500">
              Peg din telefon mod QR-koden for at åbne bot-chatten
            </p>
          </div>
        </div>
        
        {/* Instructions */}
        <div className="mt-16 bg-blue-50 border border-blue-200 rounded-xl p-8">
          <h3 className="text-xl font-semibold text-blue-900 mb-4">
            Hvad sker der når du starter bot-chatten?
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">
                1
              </div>
              <div>
                <h4 className="font-semibold text-blue-900 mb-1">Velkomstbesked</h4>
                <p className="text-blue-700 text-sm">Botten sender dig en velkomstbesked med instruktioner</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">
                2
              </div>
              <div>
                <h4 className="font-semibold text-blue-900 mb-1">Send læge URL</h4>
                <p className="text-blue-700 text-sm">Du sender findlæge.dk URL'en til den læge du vil overvåge</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-1">
                3
              </div>
              <div>
                <h4 className="font-semibold text-blue-900 mb-1">Bekræftelse</h4>
                <p className="text-blue-700 text-sm">Botten bekræfter og starter overvågning af lægen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BotAccess